<!--
 * @Author: your name
 * @Date: 2021-08-11 10:28:25
 * @LastEditTime: 2021-08-13 14:29:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \qdBillingSystem\src\pages\siteinfo\JCResourcePool\JCResourcePool.vue
-->
<template>
  <div class="JCResourcePool">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        ><span style="color:#409EFF;">网站信息管理</span></el-breadcrumb-item
      >
      <el-breadcrumb-item>健驰资源池</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs
      style="background:#fff;margin-top:10px;"
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
    >
      <el-tab-pane label="部门资源池" name="1"></el-tab-pane>
      <el-tab-pane label="健驰资源池" name="2"></el-tab-pane>
    </el-tabs>
    <div class="basic">
      <div class="header">
        <span>查询客户</span>
        <p v-if="!show" @click="show = true">收起</p>
        <p v-if="show" @click="show = false">展开</p>
      </div>
      <el-collapse-transition>
        <div class="inquiry" v-show="!show">
          <el-form label-width="80px" size="small" ref="form" :form="queryForm">
            <el-form-item label="客户信息">
              <el-input placeholder="请输入客户手机号码/姓名"></el-input>
            </el-form-item>
            <el-form-item label="渠道名称">
              <el-select
                clearable
                v-model="queryForm.value"
                placeholder="请选择渠道"
              >
                <el-option value="1" label="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="资源时间">
              <el-date-picker
                v-model="queryForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!-- <div class="boxBtns">
      <div></div>
      <el-button type="primary" size="mini" @click="show = false" v-if="show"
        >搜索展开</el-button
      >
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "1",
      show: false,
      queryForm: {
        date: [],
      },
    };
  },
  created() {},
  methods: {
    handleClick(e) {},
  },
};
</script>
<style lang="scss" scoped>
.JCResourcePool {
  .basic {
    background: #fff;
    padding: 10px;
    position: relative;
    .infoShow {
      position: absolute;
      top: -5px;
      right: 0;
      z-index: 10;
      width: 32px;
      height: 32px;
      img {
        width: 32px;
        height: 32px;
      }
    }
    .header {
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      span {
        font-size: 15px;

        color: #333;
      }
      p {
        font-size: 12px;
        color: #2d7edf;
      }
      p:hover {
        cursor: pointer;
      }
    }
  }
  .boxBtns {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  /deep/.el-form {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/.el-input {
    display: inline-block;
    width: 200px;
    vertical-align: middle;
  }

  /deep/.el-input__inner {
    width: 200px;
    line-height: 30px;
    margin-left: 10px;
  }
}
</style>
